import userService from '../../services/userService';

const state = {
  users: [],
  roles: []
};

const getters = {
  allUsers: state => state.users,
  allRoles: state => state.roles
};

const actions = {
  async fetchUsers({ commit }, filters = {}) {
    try {
      console.log('Fetching users with filters:', filters); // Debug log
      const response = await userService.getUsers(filters);
      console.log('Store received response:', response); // Debug log
      commit('setUsers', response.data.data);
    } catch (error) {
      console.error('Store error:', error);
      commit('setUsers', []);
    }
  },
  async addUser({ commit }, user) {
    const response = await userService.addUser(user);
    commit('newUser', response.data);
  },
  async updateUser({ commit }, user) {
    const response = await userService.updateUser(user.id, user);
    commit('updateUser', response.data);
  },
  async fetchRoles({ commit }) {
    try {
      const response = await userService.getRoles();
      console.log('Response from roles API:', response);
      
      // Ensure we're getting an array of roles
      const roles = Array.isArray(response) ? response : 
                   Array.isArray(response.data) ? response.data :
                   [];
                   
      commit('setRoles', roles);
    } catch (error) {
      console.error('Error fetching roles:', error);
      commit('setRoles', []);
    }
  }
};

const mutations = {
  setUsers: (state, users) => {
    state.users = users || [];
  },
  newUser: (state, user) => state.users.push(user),
  updateUser: (state, updatedUser) => {
    const index = state.users.findIndex(user => user.id === updatedUser.id);
    if (index !== -1) {
      state.users.splice(index, 1, updatedUser);
    }
  },
  setRoles: (state, roles) => {
    console.log('Setting roles in store:', roles);
    state.roles = Array.isArray(roles) ? roles : [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
